export enum PermissionType {
  None,
  View,
  Edit,
  Delete,
  Route
}